var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import Badge from '../../Atoms/Badge';
const StyledBadge = styled(Badge) `
  line-height: 1;
  background-color: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
  border: 1px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
  color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
  font-weight: 600;
  text-transform: uppercase;
`;
const TextBadge = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement(StyledBadge, Object.assign({}, rest), children));
};
export default TextBadge;
